import { api } from './api';

class DashboardV2Service {
  constructor() {
    this.baseUrl = '/v2/dashboard';
  }

  // ==================== Layout Management ====================

  /**
   * Obtener layout del usuario autenticado
   * GET /api/v2/dashboard/layout
   */
  async getLayout() {
    try {
      const response = await api.get(`${this.baseUrl}/layout`);
      return response.data;
    } catch (error) {
      console.error('Error fetching layout:', error);
      throw error;
    }
  }

  /**
   * Guardar layout completo
   * POST /api/v2/dashboard/layout
   */
  async saveLayout(layoutData) {
    try {
      const response = await api.post(`${this.baseUrl}/layout`, layoutData);
      return response.data;
    } catch (error) {
      console.error('Error saving layout:', error);
      throw error;
    }
  }

  // ==================== Widget Management ====================

  /**
   * Agregar widget individual
   * POST /api/v2/dashboard/layout/widgets
   */
  async addWidget(widgetData) {
    try {
      const response = await api.post(`${this.baseUrl}/layout/widgets`, widgetData);
      return response.data;
    } catch (error) {
      console.error('Error adding widget:', error);
      throw error;
    }
  }

  /**
   * Actualizar posiciones de widgets (drag & drop)
   * PATCH /api/v2/dashboard/layout/widgets/positions
   */
  async updateWidgetPositions(widgets) {
    try {
      const response = await api.patch(`${this.baseUrl}/layout/widgets/positions`, { widgets });
      return response.data;
    } catch (error) {
      console.error('Error updating widget positions:', error);
      throw error;
    }
  }

  /**
   * Actualizar configuración de un widget
   * PUT /api/v2/dashboard/layout/widgets/:widgetId
   */
  async updateWidget(widgetId, data) {
    try {
      const response = await api.put(`${this.baseUrl}/layout/widgets/${widgetId}`, data);
      return response.data;
    } catch (error) {
      console.error('Error updating widget:', error);
      throw error;
    }
  }

  /**
   * Eliminar widget
   * DELETE /api/v2/dashboard/layout/widgets/:widgetId
   */
  async deleteWidget(widgetId) {
    try {
      const response = await api.delete(`${this.baseUrl}/layout/widgets/${widgetId}`);
      return response.data;
    } catch (error) {
      console.error('Error deleting widget:', error);
      throw error;
    }
  }

  // ==================== Widget Data ====================

  /**
   * Obtener datos de widget time-series
   * GET /api/v2/dashboard/widgets/:widgetId/data/timeseries
   */
  async getTimeseriesData(widgetId, params = {}) {
    try {
      const response = await api.get(
        `${this.baseUrl}/widgets/${widgetId}/data/timeseries`,
        { params }
      );
      return response.data;
    } catch (error) {
      console.error('Error fetching timeseries data:', error);
      throw error;
    }
  }

  /**
   * Obtener datos de widget gauge
   * GET /api/v2/dashboard/widgets/:widgetId/data/gauge
   */
  async getGaugeData(widgetId) {
    try {
      const response = await api.get(`${this.baseUrl}/widgets/${widgetId}/data/gauge`);
      return response.data;
    } catch (error) {
      console.error('Error fetching gauge data:', error);
      throw error;
    }
  }

  /**
   * Obtener datos de widget nivel
   * GET /api/v2/dashboard/widgets/:widgetId/data/nivel
   */
  async getNivelData(widgetId) {
    try {
      const response = await api.get(`${this.baseUrl}/widgets/${widgetId}/data/nivel`);
      return response.data;
    } catch (error) {
      console.error('Error fetching nivel data:', error);
      throw error;
    }
  }

  /**
   * Obtener datos de widget KPI
   * GET /api/v2/dashboard/widgets/:widgetId/data/kpi
   */
  async getKPIData(widgetId) {
    try {
      const response = await api.get(`${this.baseUrl}/widgets/${widgetId}/data/kpi`);
      return response.data;
    } catch (error) {
      console.error('Error fetching KPI data:', error);
      throw error;
    }
  }

  /**
   * Obtener datos de múltiples widgets en batch
   * POST /api/v2/dashboard/widgets/data/batch
   */
  async getBatchWidgetData(widgetIds) {
    try {
      const response = await api.post(`${this.baseUrl}/widgets/data/batch`, {
        widgets: widgetIds
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching batch widget data:', error);
      throw error;
    }
  }

  /**
   * Helper para obtener datos de un widget según su tipo
   */
  async getWidgetData(widgetId, tipo, params = {}) {
    switch (tipo) {
      case 'timeseries':
        return this.getTimeseriesData(widgetId, params);
      case 'gauge':
        return this.getGaugeData(widgetId);
      case 'nivel':
        return this.getNivelData(widgetId);
      case 'kpi':
        return this.getKPIData(widgetId);
      default:
        throw new Error(`Tipo de widget no soportado: ${tipo}`);
    }
  }
}

export default new DashboardV2Service();
